module.exports = __webpack_public_path__ + "static/media/binance-coin.9919b1cf.svg";